import NimblePicker from 'emoji-mart/dist-es/components/picker/nimble-picker'
import { useFetchEmojiData } from 'hooks/use_fetch_emoji_data'
import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getSelectedTopicId } from 'reduxes/slices/selected/selectors'
import { toggleEmojiReaction } from 'reduxes/slices/timelines/actions'

import { MEDIA_QUERIES, css } from 'design'

import { useMediaQuery } from '../../hooks/use_media_query'
import {useAxios} from "../../hooks/use_axios";

export default function EmojiSelector({ timelineId }) {
  const dispatch = useDispatch()
  const axios = useAxios()
  const topicId = useSelector(getSelectedTopicId)
  const desktop = useMediaQuery(MEDIA_QUERIES.md)

  const { data } = useFetchEmojiData()

  const handleEmojiSelect = (emoji) => {
    if (!topicId || !timelineId || !emoji) return

    dispatch(axios(toggleEmojiReaction(topicId, timelineId, emoji.colons)))
  }

  if (!data) {
    return null
  }

  return (
    <div className={pickerStyles({ desktop })}>
      <NimblePicker
        data={data}
        onSelect={handleEmojiSelect}
        title="Pick your emoji…"
        emoji="point_up"
        set="apple"
      />
    </div>
  )
}

const pickerStyles = css({
  variants: {
    desktop: {
      false: {
        '.emoji-mart-search': {
          display: 'none',
        },
      },
    },
  },
})
